import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const SettingsBarrierTable = (props) => {
  const { t } = useTranslation();

  return (
    <div className="settings-groups">
      <table id="barrierTable">
        <thead>
          <th>{t("allgemein.info")}</th>
          <th>{t("allgemein.modus")}</th>
          <th>{t("elementeAllgemein.areaWerte.RealFree")}</th>
          <th>{t("allgemein.anzeigewert")}</th>
          <th>{t("elementeAllgemein.area")}</th>
          <th>{t("elementeAllgemein.areaPfad")}</th>
        </thead>
        <tbody>
          <td>{t("allgemein.daten")}</td>
          <td>{t("allgemein.daten")}</td>
          <td>{t("allgemein.daten")}</td>
          <td>{t("allgemein.daten")}</td>
          <td>{t("allgemein.daten")}</td>
          <td>{t("allgemein.daten")}</td>
        </tbody>
      </table>
    </div>
  );
};

export default SettingsBarrierTable;
